// import { Component } from '@theme/component';
// import { fetchConfig, debounce, onAnimationEnd, prefersReducedMotion, resetShimmer } from '@theme/utilities';
// import { morphSection, sectionRenderer } from '@theme/section-renderer';
// import {
//   ThemeEvents,
//   CartUpdateEvent,
//   QuantitySelectorUpdateEvent,
//   CartAddEvent,
//   DiscountUpdateEvent,
// } from '@theme/events';
// import { cartPerformance } from '@theme/performance';

// /** @typedef {import('./utilities').TextComponent} TextComponent */

// /**
//  * A custom element that displays a cart items component.
//  *
//  * @typedef {object} Refs
//  * @property {HTMLElement[]} quantitySelectors - The quantity selector elements.
//  * @property {HTMLTableRowElement[]} cartItemRows - The cart item rows.
//  * @property {TextComponent} cartTotal - The cart total.
//  *
//  * @extends {Component<Refs>}
//  */
// class CartItemsComponent extends Component {
//   #debouncedOnChange = debounce(this.#onQuantityChange, 300).bind(this);

//   connectedCallback() {
//     super.connectedCallback();

//     document.addEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
//     document.addEventListener(ThemeEvents.discountUpdate, this.handleDiscountUpdate);
//     document.addEventListener(ThemeEvents.quantitySelectorUpdate, this.#debouncedOnChange);
//   }

//   disconnectedCallback() {
//     super.disconnectedCallback();

//     document.removeEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
//     document.removeEventListener(ThemeEvents.quantitySelectorUpdate, this.#debouncedOnChange);
//   }

//   /**
//    * Handles QuantitySelectorUpdateEvent change event.
//    * @param {QuantitySelectorUpdateEvent} event - The event.
//    */
//   #onQuantityChange(event) {
//     const { quantity, cartLine: line } = event.detail;

//     if (!line) return;

//     if (quantity === 0) {
//       return this.onLineItemRemove(line);
//     }

//     this.updateQuantity({
//       line,
//       quantity,
//       action: 'change',
//     });
//     const lineItemRow = this.refs.cartItemRows[line - 1];

//     if (!lineItemRow) return;

//     const textComponent = /** @type {TextComponent | undefined} */ (lineItemRow.querySelector('text-component'));
//     textComponent?.shimmer();
//   }

//   /**
//    * Handles the line item removal.
//    * @param {number} line - The line item index.
//    */
//   onLineItemRemove(line) {
//     this.updateQuantity({
//       line,
//       quantity: 0,
//       action: 'clear',
//     });

//     const cartItemRowToRemove = this.refs.cartItemRows[line - 1];

//     if (!cartItemRowToRemove) return;

//     const rowsToRemove = [
//       cartItemRowToRemove,
//       // Get all nested lines of the row to remove
//       ...this.refs.cartItemRows.filter((row) => row.dataset.parentKey === cartItemRowToRemove.dataset.key),
//     ];

//     // Add class to the row to trigger the animation
//     rowsToRemove.forEach((row) => {
//       const remove = () => row.remove();

//       if (prefersReducedMotion()) return remove();

//       row.style.setProperty('--row-height', `${row.clientHeight}px`);
//       row.classList.add('removing');

//       // Remove the row after the animation ends
//       onAnimationEnd(row, remove);
//     });
//   }

//   /**
//    * Updates the quantity.
//    * @param {Object} config - The config.
//    * @param {number} config.line - The line.
//    * @param {number} config.quantity - The quantity.
//    * @param {string} config.action - The action.
//    */
//   updateQuantity(config) {
//     const cartPerformaceUpdateMarker = cartPerformance.createStartingMarker(`${config.action}:user-action`);

//     this.#disableCartItems();

//     const { line, quantity } = config;
//     const { cartTotal } = this.refs;

//     const cartItemsComponents = document.querySelectorAll('cart-items-component');
//     const sectionsToUpdate = new Set([this.sectionId]);
//     cartItemsComponents.forEach((item) => {
//       if (item instanceof HTMLElement && item.dataset.sectionId) {
//         sectionsToUpdate.add(item.dataset.sectionId);
//       }
//     });

//     const body = JSON.stringify({
//       line: line,
//       quantity: quantity,
//       sections: Array.from(sectionsToUpdate).join(','),
//       sections_url: window.location.pathname,
//     });

//     cartTotal?.shimmer();

//     fetch(`${Theme.routes.cart_change_url}`, fetchConfig('json', { body }))
//       .then((response) => {
//         return response.text();
//       })
//       .then((responseText) => {
//         const parsedResponseText = JSON.parse(responseText);

//         resetShimmer(this);

//         if (parsedResponseText.errors) {
//           this.#handleCartError(line, parsedResponseText);
//           return;
//         }

//         const newSectionHTML = new DOMParser().parseFromString(
//           parsedResponseText.sections[this.sectionId],
//           'text/html'
//         );

//         // Grab the new cart item count from a hidden element
//         const newCartHiddenItemCount = newSectionHTML.querySelector('[ref="cartItemCount"]')?.textContent;
//         const newCartItemCount = newCartHiddenItemCount ? parseInt(newCartHiddenItemCount, 10) : 0;

//         // Update data-cart-quantity for all matching variants
//         this.#updateQuantitySelectors(parsedResponseText);

//         this.dispatchEvent(
//           new CartUpdateEvent({}, this.sectionId, {
//             itemCount: newCartItemCount,
//             source: 'cart-items-component',
//             sections: parsedResponseText.sections,
//           })
//         );

//         morphSection(this.sectionId, parsedResponseText.sections[this.sectionId]);
//                 this.#enforceHuilierPricing();

//         this.#updateCartQuantitySelectorButtonStates();
//       })
//       .catch((error) => {
//         console.error(error);
//       })
//       .finally(() => {
//         this.#enableCartItems();
//         cartPerformance.measureFromMarker(cartPerformaceUpdateMarker);
//       });
//   }

//   /**
//    * Handles the discount update.
//    * @param {DiscountUpdateEvent} event - The event.
//    */
//   handleDiscountUpdate = (event) => {
//     this.#handleCartUpdate(event);
//   };

//   /**
//    * Handles the cart error.
//    * @param {number} line - The line.
//    * @param {Object} parsedResponseText - The parsed response text.
//    * @param {string} parsedResponseText.errors - The errors.
//    */
//   #handleCartError = (line, parsedResponseText) => {
//     const quantitySelector = this.refs.quantitySelectors[line - 1];
//     const quantityInput = quantitySelector?.querySelector('input');

//     if (!quantityInput) throw new Error('Quantity input not found');

//     quantityInput.value = quantityInput.defaultValue;

//     const cartItemError = this.refs[`cartItemError-${line}`];
//     const cartItemErrorContainer = this.refs[`cartItemErrorContainer-${line}`];

//     if (!(cartItemError instanceof HTMLElement)) throw new Error('Cart item error not found');
//     if (!(cartItemErrorContainer instanceof HTMLElement)) throw new Error('Cart item error container not found');

//     cartItemError.textContent = parsedResponseText.errors;
//     cartItemErrorContainer.classList.remove('hidden');
//   };

//   /**
//    * Handles the cart update.
//    *
//    * @param {DiscountUpdateEvent | CartUpdateEvent | CartAddEvent} event
//    */
//   #handleCartUpdate = (event) => {
//     if (event instanceof DiscountUpdateEvent) {
//       sectionRenderer.renderSection(this.sectionId, { cache: false });
//       return;
//     }
//     if (event.target === this) return;

//     const cartItemsHtml = event.detail.data.sections?.[this.sectionId];
//     if (cartItemsHtml) {
//       morphSection(this.sectionId, cartItemsHtml);

//       // Update button states for all cart quantity selectors after morph
//       this.#updateCartQuantitySelectorButtonStates();
//          this.#enforceHuilierPricing();
//     } else {
//       sectionRenderer.renderSection(this.sectionId, { cache: false });
//     }
//   };
//   // --- Cantaria: huilier member pricing guard ---
//   #huilierSwapLock = false;

//   async #enforceHuilierPricing() {
//     if (this.#huilierSwapLock) return;
//     this.#huilierSwapLock = true;

//     try {
//       // 1) Read cart
//       const cartRes = await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
//       const cart = await cartRes.json();

//       const hasSubscription = (cart.items || []).some((item) => !!item.selling_plan_allocation);

//       const REGULAR_250 = 63258420216157;
//       const MEMBER_250  = 63546742571357;
//       const REGULAR_500 = 63258420248925;
//       const MEMBER_500  = 63546742604125;

//       const qtyById = (id) =>
//         (cart.items || [])
//           .filter((it) => Number(it.variant_id) === Number(id))
//           .reduce((sum, it) => sum + (it.quantity || 0), 0);

//       const swap = async (fromId, toId, qty) => {
//         if (!qty || qty <= 0) return;

//         // remove "from"
//         await fetch(Theme.routes.cart_change_url, fetchConfig('json', {
//           body: JSON.stringify({ id: fromId, quantity: 0 }),
//         }));

//         // add "to"
//         await fetch(Theme.routes.cart_add_url, fetchConfig('json', {
//           body: JSON.stringify({ items: [{ id: toId, quantity: qty }] }),
//         }));
//       };

//       // 2) Apply rules (discount only the huilier size that matches the subscription size)
//       const subLine = (cart.items || []).find((item) => !!item.selling_plan_allocation);
//       const subText = `${subLine?.product_title || ''} ${subLine?.variant_title || ''}`.toLowerCase();

//       const wants500 = subText.includes('500');
//       const wants250 = subText.includes('250');

//       const targetSize = wants500 ? '500' : (wants250 ? '250' : null);

//       if (hasSubscription && targetSize) {
//         if (targetSize === '250') {
//           // ensure 250 is member, 500 is NOT member
//           await swap(REGULAR_250, MEMBER_250, qtyById(REGULAR_250));
//           await swap(MEMBER_500, REGULAR_500, qtyById(MEMBER_500));
//         } else {
//           // ensure 500 is member, 250 is NOT member
//           await swap(REGULAR_500, MEMBER_500, qtyById(REGULAR_500));
//           await swap(MEMBER_250, REGULAR_250, qtyById(MEMBER_250));
//         }
//       } else if (!hasSubscription) {
//         // no subscription -> revert any member variants to regular
//         await swap(MEMBER_250, REGULAR_250, qtyById(MEMBER_250));
//         await swap(MEMBER_500, REGULAR_500, qtyById(MEMBER_500));
//       }
//   }
//   /**
//    * Disables the cart items.
//    */
//   #disableCartItems() {
//     this.classList.add('cart-items-disabled');
//   }

//   /**
//    * Enables the cart items.
//    */
//   #enableCartItems() {
//     this.classList.remove('cart-items-disabled');
//   }

//   /**
//    * Updates quantity selectors for all matching variants in the cart.
//    * @param {Object} updatedCart - The updated cart object.
//    * @param {Array<{variant_id: number, quantity: number}>} [updatedCart.items] - The cart items.
//    */
//   #updateQuantitySelectors(updatedCart) {
//     if (!updatedCart.items) return;

//     for (const item of updatedCart.items) {
//       const variantId = item.variant_id.toString();
//       const selectors = document.querySelectorAll(
//         `quantity-selector-component[data-variant-id="${variantId}"], cart-quantity-selector-component[data-variant-id="${variantId}"]`
//       );

//       for (const selector of selectors) {
//         const input = selector.querySelector('input[data-cart-quantity]');
//         if (!input) continue;

//         input.setAttribute('data-cart-quantity', item.quantity.toString());

//         // Update the quantity selector's internal state
//         if ('updateCartQuantity' in selector && typeof selector.updateCartQuantity === 'function') {
//           selector.updateCartQuantity();
//         }
//       }
//     }
//   }

//   /**
//    * Updates button states for all cart quantity selector components.
//    */
//   #updateCartQuantitySelectorButtonStates() {
//     const cartQuantitySelectors = document.querySelectorAll('cart-quantity-selector-component');
//     for (const selector of cartQuantitySelectors) {
//       if ('updateButtonStates' in selector && typeof selector.updateButtonStates === 'function') {
//         selector.updateButtonStates();
//       }
//     }
//   }

//   /**
//    * Gets the section id.
//    * @returns {string} The section id.
//    */
//   get sectionId() {
//     const { sectionId } = this.dataset;

//     if (!sectionId) throw new Error('Section id missing');

//     return sectionId;
//   }
// }

// if (!customElements.get('cart-items-component')) {
//   customElements.define('cart-items-component', CartItemsComponent);
// }



// import { Component } from '@theme/component';
// import { fetchConfig, debounce, onAnimationEnd, prefersReducedMotion, resetShimmer } from '@theme/utilities';
// import { morphSection, sectionRenderer } from '@theme/section-renderer';
// import {
//   ThemeEvents,
//   CartUpdateEvent,
//   QuantitySelectorUpdateEvent,
//   CartAddEvent,
//   DiscountUpdateEvent,
// } from '@theme/events';
// import { cartPerformance } from '@theme/performance';

// /** @typedef {import('./utilities').TextComponent} TextComponent */

// /**
//  * A custom element that displays a cart items component.
//  *
//  * @typedef {object} Refs
//  * @property {HTMLElement[]} quantitySelectors - The quantity selector elements.
//  * @property {HTMLTableRowElement[]} cartItemRows - The cart item rows.
//  * @property {TextComponent} cartTotal - The cart total.
//  *
//  * @extends {Component<Refs>}
//  */
// class CartItemsComponent extends Component {
//   #debouncedOnChange = debounce(this.#onQuantityChange, 300).bind(this);

//   connectedCallback() {
//     super.connectedCallback();

//     document.addEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
//     document.addEventListener(ThemeEvents.discountUpdate, this.handleDiscountUpdate);
//     document.addEventListener(ThemeEvents.quantitySelectorUpdate, this.#debouncedOnChange);
//   }

//   disconnectedCallback() {
//     super.disconnectedCallback();

//     document.removeEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
//     document.removeEventListener(ThemeEvents.quantitySelectorUpdate, this.#debouncedOnChange);
//   }

//   /**
//    * Handles QuantitySelectorUpdateEvent change event.
//    * @param {QuantitySelectorUpdateEvent} event - The event.
//    */
//   #onQuantityChange(event) {
//     const { quantity, cartLine: line } = event.detail;

//     if (!line) return;

//     if (quantity === 0) {
//       return this.onLineItemRemove(line);
//     }

//     this.updateQuantity({
//       line,
//       quantity,
//       action: 'change',
//     });
//     const lineItemRow = this.refs.cartItemRows[line - 1];

//     if (!lineItemRow) return;

//     const textComponent = /** @type {TextComponent | undefined} */ (lineItemRow.querySelector('text-component'));
//     textComponent?.shimmer();
//   }

//   /**
//    * Handles the line item removal.
//    * @param {number} line - The line item index.
//    */
//   onLineItemRemove(line) {
//     this.updateQuantity({
//       line,
//       quantity: 0,
//       action: 'clear',
//     });

//     const cartItemRowToRemove = this.refs.cartItemRows[line - 1];

//     if (!cartItemRowToRemove) return;

//     const rowsToRemove = [
//       cartItemRowToRemove,
//       // Get all nested lines of the row to remove
//       ...this.refs.cartItemRows.filter((row) => row.dataset.parentKey === cartItemRowToRemove.dataset.key),
//     ];

//     // Add class to the row to trigger the animation
//     rowsToRemove.forEach((row) => {
//       const remove = () => row.remove();

//       if (prefersReducedMotion()) return remove();

//       row.style.setProperty('--row-height', `${row.clientHeight}px`);
//       row.classList.add('removing');

//       // Remove the row after the animation ends
//       onAnimationEnd(row, remove);
//     });
//   }

//   /**
//    * Updates the quantity.
//    * @param {Object} config - The config.
//    * @param {number} config.line - The line.
//    * @param {number} config.quantity - The quantity.
//    * @param {string} config.action - The action.
//    */
//   updateQuantity(config) {
//     const cartPerformaceUpdateMarker = cartPerformance.createStartingMarker(`${config.action}:user-action`);

//     this.#disableCartItems();

//     const { line, quantity } = config;
//     const { cartTotal } = this.refs;

//     const cartItemsComponents = document.querySelectorAll('cart-items-component');
//     const sectionsToUpdate = new Set([this.sectionId]);
//     cartItemsComponents.forEach((item) => {
//       if (item instanceof HTMLElement && item.dataset.sectionId) {
//         sectionsToUpdate.add(item.dataset.sectionId);
//       }
//     });

//     const body = JSON.stringify({
//       line: line,
//       quantity: quantity,
//       sections: Array.from(sectionsToUpdate).join(','),
//       sections_url: window.location.pathname,
//     });

//     cartTotal?.shimmer();

//     fetch(`${Theme.routes.cart_change_url}`, fetchConfig('json', { body }))
//       .then((response) => {
//         return response.text();
//       })
//       .then((responseText) => {
//         const parsedResponseText = JSON.parse(responseText);

//         resetShimmer(this);

//         if (parsedResponseText.errors) {
//           this.#handleCartError(line, parsedResponseText);
//           return;
//         }

//         const newSectionHTML = new DOMParser().parseFromString(
//           parsedResponseText.sections[this.sectionId],
//           'text/html'
//         );

//         // Grab the new cart item count from a hidden element
//         const newCartHiddenItemCount = newSectionHTML.querySelector('[ref="cartItemCount"]')?.textContent;
//         const newCartItemCount = newCartHiddenItemCount ? parseInt(newCartHiddenItemCount, 10) : 0;

//         // Update data-cart-quantity for all matching variants
//         this.#updateQuantitySelectors(parsedResponseText);

//         this.dispatchEvent(
//           new CartUpdateEvent({}, this.sectionId, {
//             itemCount: newCartItemCount,
//             source: 'cart-items-component',
//             sections: parsedResponseText.sections,
//           })
//         );

//         morphSection(this.sectionId, parsedResponseText.sections[this.sectionId]);
//         this.#enforceHuilierPricing();

//         this.#updateCartQuantitySelectorButtonStates();
//       })
//       .catch((error) => {
//         console.error(error);
//       })
//       .finally(() => {
//         this.#enableCartItems();
//         cartPerformance.measureFromMarker(cartPerformaceUpdateMarker);
//       });
//   }

//   /**
//    * Updates the selling plan for a line item.
//    * @param {string} itemKey - The cart item key.
//    * @param {string} sellingPlanId - The selling plan ID.
//    */
//   updateSellingPlan(itemKey, sellingPlanId) {
//     this.#disableCartItems();

//     const sectionsToUpdate = new Set([this.sectionId]);
//     document.querySelectorAll('cart-items-component').forEach((item) => {
//       if (item instanceof HTMLElement && item.dataset.sectionId) {
//         sectionsToUpdate.add(item.dataset.sectionId);
//       }
//     });

//     const body = JSON.stringify({
//       id: itemKey,
//       selling_plan: sellingPlanId || null,
//       sections: Array.from(sectionsToUpdate).join(','),
//       sections_url: window.location.pathname,
//     });

//     fetch(`${Theme.routes.cart_change_url}`, fetchConfig('json', { body }))
//       .then(res => res.json())
//       .then(data => {
//         if (data.sections) {
//           morphSection(this.sectionId, data.sections[this.sectionId]);
//           this.dispatchEvent(new CartUpdateEvent(data, this.sectionId, {
//             itemCount: data.item_count,
//             sections: data.sections,
//             source: 'selling-plan-update'
//           }));
//           this.#enforceHuilierPricing();
//           this.#updateCartQuantitySelectorButtonStates();
//         } else {
//           window.location.reload();
//         }
//       })
//       .catch(e => console.error(e))
//       .finally(() => this.#enableCartItems());
//   }

//   /**
//    * Handles the discount update.
//    * @param {DiscountUpdateEvent} event - The event.
//    */
//   handleDiscountUpdate = (event) => {
//     this.#handleCartUpdate(event);
//   };

//   /**
//    * Handles the cart error.
//    * @param {number} line - The line.
//    * @param {Object} parsedResponseText - The parsed response text.
//    * @param {string} parsedResponseText.errors - The errors.
//    */
//   #handleCartError = (line, parsedResponseText) => {
//     const quantitySelector = this.refs.quantitySelectors[line - 1];
//     const quantityInput = quantitySelector?.querySelector('input');

//     if (!quantityInput) throw new Error('Quantity input not found');

//     quantityInput.value = quantityInput.defaultValue;

//     const cartItemError = this.refs[`cartItemError-${line}`];
//     const cartItemErrorContainer = this.refs[`cartItemErrorContainer-${line}`];

//     if (!(cartItemError instanceof HTMLElement)) throw new Error('Cart item error not found');
//     if (!(cartItemErrorContainer instanceof HTMLElement)) throw new Error('Cart item error container not found');

//     cartItemError.textContent = parsedResponseText.errors;
//     cartItemErrorContainer.classList.remove('hidden');
//   };

//   /**
//    * Handles the cart update.
//    *
//    * @param {DiscountUpdateEvent | CartUpdateEvent | CartAddEvent} event
//    */
//   #handleCartUpdate = (event) => {
//     if (event instanceof DiscountUpdateEvent) {
//       sectionRenderer.renderSection(this.sectionId, { cache: false });
//       return;
//     }
//     if (event.target === this) return;

//     const cartItemsHtml = event.detail.data.sections?.[this.sectionId];
//     if (cartItemsHtml) {
//       morphSection(this.sectionId, cartItemsHtml);

//       // Update button states for all cart quantity selectors after morph
//       this.#updateCartQuantitySelectorButtonStates();
//       this.#enforceHuilierPricing();
//     } else {
//       sectionRenderer.renderSection(this.sectionId, { cache: false });
//     }
//   };
//   // --- Cantaria: huilier member pricing guard ---
//   #huilierSwapLock = false;

//   async #enforceHuilierPricing() {
//     if (this.#huilierSwapLock) return;

//     try {
//       const response = await fetch(`${Theme.routes.cart_url}.js`, {
//         headers: { 'Accept': 'application/json' },
//         credentials: 'same-origin'
//       });
//       const cart = await response.json();

//       const hasClub = (cart.items || []).some((item) => !!item.selling_plan_allocation);
//       const REGULAR_500 = "63258420248925";
//       const MEMBER_500 = "63546742604125";

//       const dispenser = (cart.items || []).find(it =>
//         String(it.variant_id) === REGULAR_500 || String(it.variant_id) === MEMBER_500
//       );

//       if (!dispenser) return;

//       const targetId = hasClub ? MEMBER_500 : REGULAR_500;

//       if (String(dispenser.variant_id) !== String(targetId)) {
//         this.#huilierSwapLock = true;
//         this.#disableCartItems();

//         // 1. Remove current
//         await fetch(Theme.routes.cart_change_url, fetchConfig('json', {
//           body: JSON.stringify({ id: String(dispenser.key), quantity: 0 }),
//         }));

//         // 2. Add correct
//         const addRes = await fetch(Theme.routes.cart_add_url, fetchConfig('json', {
//           body: JSON.stringify({
//             items: [{ id: String(targetId), quantity: dispenser.quantity }],
//             sections: this.sectionId
//           }),
//         }));

//         const addData = await addRes.json();

//         // 3. Update UI via morphing if sections returned, else reload
//         if (addData.sections && addData.sections[this.sectionId]) {
//           morphSection(this.sectionId, addData.sections[this.sectionId]);
//           this.#updateCartQuantitySelectorButtonStates();
//           // Dispatch global update so other parts of UI (drawer title, etc) sync
//           this.dispatchEvent(new CartUpdateEvent(addData, this.sectionId, {
//             itemCount: addData.item_count,
//             sections: addData.sections,
//             source: 'huilier-pricing-fix'
//           }));
//         } else {
//           window.location.reload();
//         }
//       }
//     } catch (e) {
//       console.error('[Cantaria] Pricing Fix Error:', e);
//     } finally {
//       this.#huilierSwapLock = false;
//       this.#enableCartItems();
//     }
//   }

//   /**
//    * Disables the cart items.
//    */
//   #disableCartItems() {
//     this.classList.add('cart-items-disabled');
//   }

//   /**
//    * Enables the cart items.
//    */
//   #enableCartItems() {
//     this.classList.remove('cart-items-disabled');
//   }

//   /**
//    * Updates quantity selectors for all matching variants in the cart.
//    * @param {Object} updatedCart - The updated cart object.
//    * @param {Array<{variant_id: number, quantity: number}>} [updatedCart.items] - The cart items.
//    */
//   #updateQuantitySelectors(updatedCart) {
//     if (!updatedCart.items) return;

//     for (const item of updatedCart.items) {
//       const variantId = item.variant_id.toString();
//       const selectors = document.querySelectorAll(
//         `quantity-selector-component[data-variant-id="${variantId}"], cart-quantity-selector-component[data-variant-id="${variantId}"]`
//       );

//       for (const selector of selectors) {
//         const input = selector.querySelector('input[data-cart-quantity]');
//         if (!input) continue;

//         input.setAttribute('data-cart-quantity', item.quantity.toString());

//         // Update the quantity selector's internal state
//         if ('updateCartQuantity' in selector && typeof selector.updateCartQuantity === 'function') {
//           selector.updateCartQuantity();
//         }
//       }
//     }
//   }

//   /**
//    * Updates button states for all cart quantity selector components.
//    */
//   #updateCartQuantitySelectorButtonStates() {
//     const cartQuantitySelectors = document.querySelectorAll('cart-quantity-selector-component');
//     for (const selector of cartQuantitySelectors) {
//       if ('updateButtonStates' in selector && typeof selector.updateButtonStates === 'function') {
//         selector.updateButtonStates();
//       }
//     }
//   }

//   /**
//    * Gets the section id.
//    * @returns {string} The section id.
//    */
//   get sectionId() {
//     const { sectionId } = this.dataset;

//     if (!sectionId) throw new Error('Section id missing');

//     return sectionId;
//   }
// }

// if (!customElements.get('cart-items-component')) {
//   customElements.define('cart-items-component', CartItemsComponent);
// }










// import { Component } from '@theme/component';
// import { fetchConfig, debounce, onAnimationEnd, prefersReducedMotion, resetShimmer } from '@theme/utilities';
// import { morphSection, sectionRenderer } from '@theme/section-renderer';
// import {
//   ThemeEvents,
//   CartUpdateEvent,
//   QuantitySelectorUpdateEvent,
//   CartAddEvent,
//   DiscountUpdateEvent,
// } from '@theme/events';
// import { cartPerformance } from '@theme/performance';

// /** @typedef {import('./utilities').TextComponent} TextComponent */

// /**
//  * A custom element that displays a cart items component.
//  *
//  * @typedef {object} Refs
//  * @property {HTMLElement[]} quantitySelectors - The quantity selector elements.
//  * @property {HTMLTableRowElement[]} cartItemRows - The cart item rows.
//  * @property {TextComponent} cartTotal - The cart total.
//  *
//  * @extends {Component<Refs>}
//  */
// class CartItemsComponent extends Component {
//   #debouncedOnChange = debounce(this.#onQuantityChange, 300).bind(this);

//   connectedCallback() {
//     super.connectedCallback();

//     document.addEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
//     document.addEventListener(ThemeEvents.discountUpdate, this.handleDiscountUpdate);
//     document.addEventListener(ThemeEvents.quantitySelectorUpdate, this.#debouncedOnChange);
//   }

//   disconnectedCallback() {
//     super.disconnectedCallback();

//     document.removeEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
//     document.removeEventListener(ThemeEvents.quantitySelectorUpdate, this.#debouncedOnChange);
//   }

//   /**
//    * Handles QuantitySelectorUpdateEvent change event.
//    * @param {QuantitySelectorUpdateEvent} event - The event.
//    */
//   #onQuantityChange(event) {
//     const { quantity, cartLine: line } = event.detail;

//     if (!line) return;

//     if (quantity === 0) {
//       return this.onLineItemRemove(line);
//     }

//     this.updateQuantity({
//       line,
//       quantity,
//       action: 'change',
//     });
//     const lineItemRow = this.refs.cartItemRows[line - 1];

//     if (!lineItemRow) return;

//     const textComponent = /** @type {TextComponent | undefined} */ (lineItemRow.querySelector('text-component'));
//     textComponent?.shimmer();
//   }

//   /**
//    * Handles the line item removal.
//    * @param {number} line - The line item index.
//    */
//   onLineItemRemove(line) {
//     this.updateQuantity({
//       line,
//       quantity: 0,
//       action: 'clear',
//     });

//     const cartItemRowToRemove = this.refs.cartItemRows[line - 1];

//     if (!cartItemRowToRemove) return;

//     const rowsToRemove = [
//       cartItemRowToRemove,
//       // Get all nested lines of the row to remove
//       ...this.refs.cartItemRows.filter((row) => row.dataset.parentKey === cartItemRowToRemove.dataset.key),
//     ];

//     // Add class to the row to trigger the animation
//     rowsToRemove.forEach((row) => {
//       const remove = () => row.remove();

//       if (prefersReducedMotion()) return remove();

//       row.style.setProperty('--row-height', `${row.clientHeight}px`);
//       row.classList.add('removing');

//       // Remove the row after the animation ends
//       onAnimationEnd(row, remove);
//     });
//   }

//   /**
//    * Updates the quantity.
//    * @param {Object} config - The config.
//    * @param {number} config.line - The line.
//    * @param {number} config.quantity - The quantity.
//    * @param {string} config.action - The action.
//    */
//   updateQuantity(config) {
//     const cartPerformaceUpdateMarker = cartPerformance.createStartingMarker(`${config.action}:user-action`);

//     this.#disableCartItems();

//     const { line, quantity } = config;
//     const { cartTotal } = this.refs;

//     const cartItemsComponents = document.querySelectorAll('cart-items-component');
//     const sectionsToUpdate = new Set([this.sectionId]);
//     cartItemsComponents.forEach((item) => {
//       if (item instanceof HTMLElement && item.dataset.sectionId) {
//         sectionsToUpdate.add(item.dataset.sectionId);
//       }
//     });

//     const body = JSON.stringify({
//       line: line,
//       quantity: quantity,
//       sections: Array.from(sectionsToUpdate).join(','),
//       sections_url: window.location.pathname,
//     });

//     cartTotal?.shimmer();

//     fetch(`${Theme.routes.cart_change_url}`, fetchConfig('json', { body }))
//       .then((response) => {
//         return response.text();
//       })
//       .then((responseText) => {
//         const parsedResponseText = JSON.parse(responseText);

//         resetShimmer(this);

//         if (parsedResponseText.errors) {
//           this.#handleCartError(line, parsedResponseText);
//           return;
//         }

//         const newSectionHTML = new DOMParser().parseFromString(
//           parsedResponseText.sections[this.sectionId],
//           'text/html'
//         );

//         // Grab the new cart item count from a hidden element
//         const newCartHiddenItemCount = newSectionHTML.querySelector('[ref="cartItemCount"]')?.textContent;
//         const newCartItemCount = newCartHiddenItemCount ? parseInt(newCartHiddenItemCount, 10) : 0;

//         // Update data-cart-quantity for all matching variants
//         this.#updateQuantitySelectors(parsedResponseText);

//         this.dispatchEvent(
//           new CartUpdateEvent({}, this.sectionId, {
//             itemCount: newCartItemCount,
//             source: 'cart-items-component',
//             sections: parsedResponseText.sections,
//           })
//         );

//         morphSection(this.sectionId, parsedResponseText.sections[this.sectionId]);
//         this.#enforceHuilierPricing();

//         this.#updateCartQuantitySelectorButtonStates();
//       })
//       .catch((error) => {
//         console.error(error);
//       })
//       .finally(() => {
//         this.#enableCartItems();
//         cartPerformance.measureFromMarker(cartPerformaceUpdateMarker);
//       });
//   }

//   /**
//    * Updates the selling plan for a line item.
//    * @param {string} itemKey - The cart item key.
//    * @param {string} sellingPlanId - The selling plan ID.
//    */
//   updateSellingPlan(itemKey, sellingPlanId) {
//     this.#disableCartItems();

//     const sectionsToUpdate = new Set([this.sectionId]);
//     document.querySelectorAll('cart-items-component').forEach((item) => {
//       if (item instanceof HTMLElement && item.dataset.sectionId) {
//         sectionsToUpdate.add(item.dataset.sectionId);
//       }
//     });

//     const body = JSON.stringify({
//       id: itemKey,
//       selling_plan: sellingPlanId || null,
//       sections: Array.from(sectionsToUpdate).join(','),
//       sections_url: window.location.pathname,
//     });

//     fetch(`${Theme.routes.cart_change_url}`, fetchConfig('json', { body }))
//       .then(res => res.json())
//       .then(data => {
//         if (data.sections) {
//           morphSection(this.sectionId, data.sections[this.sectionId]);
//           this.dispatchEvent(new CartUpdateEvent(data, this.sectionId, {
//             itemCount: data.item_count,
//             sections: data.sections,
//             source: 'selling-plan-update'
//           }));
//           this.#enforceHuilierPricing();
//           this.#updateCartQuantitySelectorButtonStates();
//         } else {
//           window.location.reload();
//         }
//       })
//       .catch(e => console.error(e))
//       .finally(() => this.#enableCartItems());
//   }

//   /**
//    * Handles the discount update.
//    * @param {DiscountUpdateEvent} event - The event.
//    */
//   handleDiscountUpdate = (event) => {
//     this.#handleCartUpdate(event);
//   };

//   /**
//    * Handles the cart error.
//    * @param {number} line - The line.
//    * @param {Object} parsedResponseText - The parsed response text.
//    * @param {string} parsedResponseText.errors - The errors.
//    */
//   #handleCartError = (line, parsedResponseText) => {
//     const quantitySelector = this.refs.quantitySelectors[line - 1];
//     const quantityInput = quantitySelector?.querySelector('input');

//     if (!quantityInput) throw new Error('Quantity input not found');

//     quantityInput.value = quantityInput.defaultValue;

//     const cartItemError = this.refs[`cartItemError-${line}`];
//     const cartItemErrorContainer = this.refs[`cartItemErrorContainer-${line}`];

//     if (!(cartItemError instanceof HTMLElement)) throw new Error('Cart item error not found');
//     if (!(cartItemErrorContainer instanceof HTMLElement)) throw new Error('Cart item error container not found');

//     cartItemError.textContent = parsedResponseText.errors;
//     cartItemErrorContainer.classList.remove('hidden');
//   };

//   /**
//    * Handles the cart update.
//    *
//    * @param {DiscountUpdateEvent | CartUpdateEvent | CartAddEvent} event
//    */
//   #handleCartUpdate = (event) => {
//     if (event instanceof DiscountUpdateEvent) {
//       sectionRenderer.renderSection(this.sectionId, { cache: false });
//       return;
//     }
//     if (event.target === this) return;

//     const cartItemsHtml = event.detail.data.sections?.[this.sectionId];
//     if (cartItemsHtml) {
//       morphSection(this.sectionId, cartItemsHtml);

//       // Update button states for all cart quantity selectors after morph
//       this.#updateCartQuantitySelectorButtonStates();
//       this.#enforceHuilierPricing();
//     } else {
//       sectionRenderer.renderSection(this.sectionId, { cache: false });
//     }
//   };
//   // --- Cantaria: huilier member pricing guard ---
//   #huilierSwapLock = false;

//   async #enforceHuilierPricing() {
//     if (this.#huilierSwapLock) return;

//     try {
//       const response = await fetch(`${Theme.routes.cart_url}.js`, {
//         headers: { 'Accept': 'application/json' },
//         credentials: 'same-origin'
//       });
//       const cart = await response.json();

//       const hasClub = (cart.items || []).some((item) => !!item.selling_plan_allocation);
//       const REGULAR_500 = "63258420248925";
//       const MEMBER_500 = "63546742604125";

//       const dispenser = (cart.items || []).find(it =>
//         String(it.variant_id) === REGULAR_500 || String(it.variant_id) === MEMBER_500
//       );

//       if (!dispenser) return;

//       const targetId = hasClub ? MEMBER_500 : REGULAR_500;

//       if (String(dispenser.variant_id) !== String(targetId)) {
//         this.#huilierSwapLock = true;
//         this.#disableCartItems();

//         try {
//           const body = JSON.stringify({
//             updates: {
//               [String(dispenser.key)]: 0,
//               [String(targetId)]: dispenser.quantity
//             },
//             sections: this.sectionId,
//             sections_url: window.location.pathname
//           });

//           const updateRes = await fetch(`${Theme.routes.cart_url}/update.js`, {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
//             body
//           });

//           const data = await updateRes.json();

//           if (data.sections && data.sections[this.sectionId]) {
//             morphSection(this.sectionId, data.sections[this.sectionId]);
//             this.#updateCartQuantitySelectorButtonStates();
//             this.dispatchEvent(new CartUpdateEvent(data, this.sectionId, {
//               itemCount: data.item_count,
//               sections: data.sections,
//               source: 'huilier-pricing-fix'
//             }));
//           } else {
//             // Fallback to manual render if sections missing, instead of full reload
//             sectionRenderer.renderSection(this.sectionId, { cache: false });
//           }
//         } catch (err) {
//           console.error('[Cantaria] Swap failed:', err);
//         }
//       }

//     } catch (e) {
//       console.error('[Cantaria] Pricing Fix Error:', e);
//     } finally {
//       this.#huilierSwapLock = false;
//       this.#enableCartItems();
//     }
//   }

//   /**
//    * Disables the cart items.
//    */
//   #disableCartItems() {
//     this.classList.add('cart-items-disabled');
//   }

//   /**
//    * Enables the cart items.
//    */
//   #enableCartItems() {
//     this.classList.remove('cart-items-disabled');
//   }

//   /**
//    * Updates quantity selectors for all matching variants in the cart.
//    * @param {Object} updatedCart - The updated cart object.
//    * @param {Array<{variant_id: number, quantity: number}>} [updatedCart.items] - The cart items.
//    */
//   #updateQuantitySelectors(updatedCart) {
//     if (!updatedCart.items) return;

//     for (const item of updatedCart.items) {
//       const variantId = item.variant_id.toString();
//       const selectors = document.querySelectorAll(
//         `quantity-selector-component[data-variant-id="${variantId}"], cart-quantity-selector-component[data-variant-id="${variantId}"]`
//       );

//       for (const selector of selectors) {
//         const input = selector.querySelector('input[data-cart-quantity]');
//         if (!input) continue;

//         input.setAttribute('data-cart-quantity', item.quantity.toString());

//         // Update the quantity selector's internal state
//         if ('updateCartQuantity' in selector && typeof selector.updateCartQuantity === 'function') {
//           selector.updateCartQuantity();
//         }
//       }
//     }
//   }

//   /**
//    * Updates button states for all cart quantity selector components.
//    */
//   #updateCartQuantitySelectorButtonStates() {
//     const cartQuantitySelectors = document.querySelectorAll('cart-quantity-selector-component');
//     for (const selector of cartQuantitySelectors) {
//       if ('updateButtonStates' in selector && typeof selector.updateButtonStates === 'function') {
//         selector.updateButtonStates();
//       }
//     }
//   }

//   /**
//    * Gets the section id.
//    * @returns {string} The section id.
//    */
//   get sectionId() {
//     const { sectionId } = this.dataset;

//     if (!sectionId) throw new Error('Section id missing');

//     return sectionId;
//   }
// }

// if (!customElements.get('cart-items-component')) {
//   customElements.define('cart-items-component', CartItemsComponent);
// }







import { Component } from '@theme/component';
import { fetchConfig, debounce, onAnimationEnd, prefersReducedMotion, resetShimmer } from '@theme/utilities';
import { morphSection, sectionRenderer } from '@theme/section-renderer';
import {
  ThemeEvents,
  CartUpdateEvent,
  QuantitySelectorUpdateEvent,
  CartAddEvent,
  DiscountUpdateEvent,
} from '@theme/events';
import { cartPerformance } from '@theme/performance';

/** @typedef {import('./utilities').TextComponent} TextComponent */

/**
 * A custom element that displays a cart items component.
 *
 * @typedef {object} Refs
 * @property {HTMLElement[]} quantitySelectors - The quantity selector elements.
 * @property {HTMLTableRowElement[]} cartItemRows - The cart item rows.
 * @property {TextComponent} cartTotal - The cart total.
 *
 * @extends {Component<Refs>}
 */
class CartItemsComponent extends Component {
  #debouncedOnChange = debounce(this.#onQuantityChange, 300).bind(this);

  connectedCallback() {
    super.connectedCallback();

    document.addEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
    document.addEventListener(ThemeEvents.discountUpdate, this.handleDiscountUpdate);
    document.addEventListener(ThemeEvents.quantitySelectorUpdate, this.#debouncedOnChange);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    document.removeEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
    document.removeEventListener(ThemeEvents.quantitySelectorUpdate, this.#debouncedOnChange);
  }

  /**
   * Handles QuantitySelectorUpdateEvent change event.
   * @param {QuantitySelectorUpdateEvent} event - The event.
   */
  #onQuantityChange(event) {
    const { quantity, cartLine: line } = event.detail;

    if (!line) return;

    if (quantity === 0) {
      return this.onLineItemRemove(line);
    }

    this.updateQuantity({
      line,
      quantity,
      action: 'change',
    });
    const lineItemRow = this.refs.cartItemRows[line - 1];

    if (!lineItemRow) return;

    const textComponent = /** @type {TextComponent | undefined} */ (lineItemRow.querySelector('text-component'));
    textComponent?.shimmer();
  }

  /**
   * Handles the line item removal.
   * @param {number} line - The line item index.
   */
  onLineItemRemove(line) {
    this.updateQuantity({
      line,
      quantity: 0,
      action: 'clear',
    });

    const cartItemRowToRemove = this.refs.cartItemRows[line - 1];

    if (!cartItemRowToRemove) return;

    const rowsToRemove = [
      cartItemRowToRemove,
      // Get all nested lines of the row to remove
      ...this.refs.cartItemRows.filter((row) => row.dataset.parentKey === cartItemRowToRemove.dataset.key),
    ];

    // Add class to the row to trigger the animation
    rowsToRemove.forEach((row) => {
      const remove = () => row.remove();

      if (prefersReducedMotion()) return remove();

      row.style.setProperty('--row-height', `${row.clientHeight}px`);
      row.classList.add('removing');

      // Remove the row after the animation ends
      onAnimationEnd(row, remove);
    });
  }

  /**
   * Updates the quantity.
   * @param {Object} config - The config.
   * @param {number} config.line - The line.
   * @param {number} config.quantity - The quantity.
   * @param {string} config.action - The action.
   */
  updateQuantity(config) {
    const cartPerformaceUpdateMarker = cartPerformance.createStartingMarker(`${config.action}:user-action`);

    this.#disableCartItems();

    const { line, quantity } = config;
    const { cartTotal } = this.refs;

    const cartItemsComponents = document.querySelectorAll('cart-items-component');
    const sectionsToUpdate = new Set([this.sectionId]);
    cartItemsComponents.forEach((item) => {
      if (item instanceof HTMLElement && item.dataset.sectionId) {
        sectionsToUpdate.add(item.dataset.sectionId);
      }
    });

    const body = JSON.stringify({
      line: line,
      quantity: quantity,
      sections: Array.from(sectionsToUpdate).join(','),
      sections_url: window.location.pathname,
    });

    cartTotal?.shimmer();

    fetch(`${Theme.routes.cart_change_url}`, fetchConfig('json', { body }))
      .then((response) => response.text())
      .then((responseText) => {
        const parsedResponseText = JSON.parse(responseText);

        resetShimmer(this);

        if (parsedResponseText.errors) {
          this.#handleCartError(line, parsedResponseText);
          return;
        }

        const newSectionHTML = new DOMParser().parseFromString(
          parsedResponseText.sections[this.sectionId],
          'text/html'
        );

        const newCartHiddenItemCount = newSectionHTML.querySelector('[ref="cartItemCount"]')?.textContent;
        const newCartItemCount = newCartHiddenItemCount ? parseInt(newCartHiddenItemCount, 10) : 0;

        this.#updateQuantitySelectors(parsedResponseText);

        this.dispatchEvent(
          new CartUpdateEvent({}, this.sectionId, {
            itemCount: newCartItemCount,
            source: 'cart-items-component',
            sections: parsedResponseText.sections,
          })
        );

        document.dispatchEvent(new CustomEvent('cart:update', {
  detail: { itemCount: newCartItemCount }
}));
        morphSection(this.sectionId, parsedResponseText.sections[this.sectionId]);

        const currentCart = document.querySelector(`cart-items-component[data-section-id="${this.sectionId}"]`);
        if (currentCart) {
          currentCart.classList.remove('cart-items-disabled');
        }

        this.#enforceHuilierPricing();
        this.#updateCartQuantitySelectorButtonStates();
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.#enableCartItems();
        cartPerformance.measureFromMarker(cartPerformaceUpdateMarker);
      });
  }

  /**
   * Updates the selling plan for a line item.
   * @param {string} itemKey - The cart item key.
   * @param {string} sellingPlanId - The selling plan ID.
   */
  updateSellingPlan(itemKey, sellingPlanId) {
    this.#disableCartItems();

    const sectionsToUpdate = new Set([this.sectionId]);
    document.querySelectorAll('cart-items-component').forEach((item) => {
      if (item instanceof HTMLElement && item.dataset.sectionId) {
        sectionsToUpdate.add(item.dataset.sectionId);
      }
    });

    const body = JSON.stringify({
      id: itemKey,
      selling_plan: sellingPlanId || null,
      sections: Array.from(sectionsToUpdate).join(','),
      sections_url: window.location.pathname,
    });

    fetch(`${Theme.routes.cart_change_url}`, fetchConfig('json', { body }))
      .then(res => res.json())
      .then(data => {
        if (data.sections) {
          morphSection(this.sectionId, data.sections[this.sectionId]);
          this.dispatchEvent(new CartUpdateEvent(data, this.sectionId, {
            itemCount: data.item_count,
            sections: data.sections,
            source: 'selling-plan-update'
          }));
          this.#enforceHuilierPricing();
          this.#updateCartQuantitySelectorButtonStates();
        } else {
          window.location.reload();
        }
      })
      .catch(e => console.error(e))
      .finally(() => this.#enableCartItems());
  }

  /**
   * Handles the discount update.
   * @param {DiscountUpdateEvent} event - The event.
   */
  handleDiscountUpdate = (event) => {
    this.#handleCartUpdate(event);
  };

  /**
   * Handles the cart error.
   * @param {number} line - The line.
   * @param {Object} parsedResponseText - The parsed response text.
   * @param {string} parsedResponseText.errors - The errors.
   */
  #handleCartError = (line, parsedResponseText) => {
    const quantitySelector = this.refs.quantitySelectors[line - 1];
    const quantityInput = quantitySelector?.querySelector('input');

    if (!quantityInput) throw new Error('Quantity input not found');

    quantityInput.value = quantityInput.defaultValue;

    const cartItemError = this.refs[`cartItemError-${line}`];
    const cartItemErrorContainer = this.refs[`cartItemErrorContainer-${line}`];

    if (!(cartItemError instanceof HTMLElement)) throw new Error('Cart item error not found');
    if (!(cartItemErrorContainer instanceof HTMLElement)) throw new Error('Cart item error container not found');

    cartItemError.textContent = parsedResponseText.errors;
    cartItemErrorContainer.classList.remove('hidden');
  };

  /**
   * Handles the cart update.
   *
   * @param {DiscountUpdateEvent | CartUpdateEvent | CartAddEvent} event
   */
  #handleCartUpdate = (event) => {
    if (event instanceof DiscountUpdateEvent) {
      sectionRenderer.renderSection(this.sectionId, { cache: false });
      return;
    }
    if (event.target === this) return;

  const cartItemsHtml = event.detail?.data?.sections?.[this.sectionId] || event.detail?.sections?.[this.sectionId];
    if (cartItemsHtml) {
      morphSection(this.sectionId, cartItemsHtml);

      // Update button states for all cart quantity selectors after morph
      this.#updateCartQuantitySelectorButtonStates();
      this.#enforceHuilierPricing();
    } else {
      sectionRenderer.renderSection(this.sectionId, { cache: false });
    }
  };

  // --- Cantaria: huilier member pricing guard ---
  #huilierSwapLock = false;

    async #enforceHuilierPricing() {
    if (this.#huilierSwapLock) return;

    try {
      const cartRes = await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
      const cart = await cartRes.json();
      const items = cart.items || [];

      // 1. Count subscriptions (Olive Oil Club)
      const subCount = items.reduce((acc, it) => {
        if (it.selling_plan_allocation) return acc + it.quantity;
        return acc;
      }, 0);

      // 2. Define IDs
      const REGULAR_250 = 63258420216157;
      const MEMBER_250 = 63546742571357;
      const REGULAR_500 = 63258420248925;
      const MEMBER_500 = 63546742604125;

      // 3. Count current dispenser states
      const memberQty250 = items.filter(it => Number(it.variant_id) === Number(MEMBER_250)).reduce((acc, it) => acc + it.quantity, 0);
      const regularQty250 = items.filter(it => Number(it.variant_id) === Number(REGULAR_250)).reduce((acc, it) => acc + it.quantity, 0);
      const memberQty500 = items.filter(it => Number(it.variant_id) === Number(MEMBER_500)).reduce((acc, it) => acc + it.quantity, 0);
      const regularQty500 = items.filter(it => Number(it.variant_id) === Number(REGULAR_500)).reduce((acc, it) => acc + it.quantity, 0);

      const totalMemberQty = memberQty250 + memberQty500;
      const totalDispenserQty = totalMemberQty + regularQty250 + regularQty500;

      if (totalDispenserQty === 0) return;

      // 4. Determine Target States
      // We want exactly Math.min(subCount, totalDispenserQty) to be Member variants.
      const targetMemberQty = Math.min(subCount, totalDispenserQty);

      if (totalMemberQty === targetMemberQty) return;

      this.#huilierSwapLock = true;

      const updates = {};
      const itemsToAdd = [];

      // Logic:
      // If totalMemberQty > targetMemberQty -> Need to downgrade some Members to Regular
      // If totalMemberQty < targetMemberQty -> Need to upgrade some Regulars to Member

      if (totalMemberQty > targetMemberQty) {
        let toDowngrade = totalMemberQty - targetMemberQty;

        // Downgrade 500 first, then 250
        if (memberQty500 > 0 && toDowngrade > 0) {
          const num = Math.min(memberQty500, toDowngrade);
          updates[MEMBER_500] = 0; // Remove member
          itemsToAdd.push({ id: REGULAR_500, quantity: num });
          // If we had remaining member500 that didn't need downgrade, restore them
          if (memberQty500 > num) itemsToAdd.push({ id: MEMBER_500, quantity: memberQty500 - num });
          toDowngrade -= num;
        }
        if (memberQty250 > 0 && toDowngrade > 0) {
          const num = Math.min(memberQty250, toDowngrade);
          updates[MEMBER_250] = 0;
          itemsToAdd.push({ id: REGULAR_250, quantity: num });
          if (memberQty250 > num) itemsToAdd.push({ id: MEMBER_250, quantity: memberQty250 - num });
          toDowngrade -= num;
        }
      } else {
        let toUpgrade = targetMemberQty - totalMemberQty;

        // Upgrade 500 first, then 250
        if (regularQty500 > 0 && toUpgrade > 0) {
          const num = Math.min(regularQty500, toUpgrade);
          updates[REGULAR_500] = 0;
          itemsToAdd.push({ id: MEMBER_500, quantity: num });
          if (regularQty500 > num) itemsToAdd.push({ id: REGULAR_500, quantity: regularQty500 - num });
          toUpgrade -= num;
        }
        if (regularQty250 > 0 && toUpgrade > 0) {
          const num = Math.min(regularQty250, toUpgrade);
          updates[REGULAR_250] = 0;
          itemsToAdd.push({ id: MEMBER_250, quantity: num });
          if (regularQty250 > num) itemsToAdd.push({ id: REGULAR_250, quantity: regularQty250 - num });
          toUpgrade -= num;
        }
      }

      if (Object.keys(updates).length > 0 || itemsToAdd.length > 0) {
        // Collect all sections that might need refreshing (drawer, count, etc)
        const sections = Array.from(document.querySelectorAll('[data-section-id]'))
          .map(el => el.dataset.sectionId)
          .filter(Boolean);

        let finalSections = null;
        let finalItemCount = 0;

        // Perform update
        if (Object.keys(updates).length > 0) {
          const upRes = await fetch(Theme.routes.cart_update_url, fetchConfig('json', {
            body: JSON.stringify({ updates, sections: sections.join(',') })
          }));
          const upData = await upRes.json();
          finalSections = upData.sections;
          finalItemCount = upData.item_count;
        }

        if (itemsToAdd.length > 0) {
          const addRes = await fetch(Theme.routes.cart_add_url, fetchConfig('json', {
            body: JSON.stringify({ items: itemsToAdd, sections: sections.join(',') })
          }));
          const addData = await addRes.json();
          if (addData.sections) finalSections = addData.sections;
          if (addData.item_count) finalItemCount = addData.item_count;
        }

        // Dispatch native theme events to refresh the UI
        if (finalSections) {
          const eventDetail = {
            bubbles: true,
            detail: {
              data: { sections: finalSections },
              itemCount: finalItemCount,
              source: 'cart-items'
            }
          };
          document.dispatchEvent(new CustomEvent('cart:update', eventDetail));
          document.dispatchEvent(new CustomEvent('cart:updated'));
        }
      }
    } catch (e) {
      console.warn('[Huilier] Swap failed:', e);
    } finally {
      this.#huilierSwapLock = false;
    }
  }
    #disableCartItems() {
      const root = document.querySelector(`cart-items-component[data-section-id="${this.sectionId}"]`);
      (root || this).classList.add('cart-items-disabled');
    }

    #enableCartItems() {
      const root = document.querySelector(`cart-items-component[data-section-id="${this.sectionId}"]`);
      (root || this).classList.remove('cart-items-disabled');
    }
  /**
   * Updates quantity selectors for all matching variants in the cart.
   * @param {Object} updatedCart - The updated cart object.
   * @param {Array<{variant_id: number, quantity: number}>} [updatedCart.items] - The cart items.
   */
  #updateQuantitySelectors(updatedCart) {
    if (!updatedCart.items) return;

    for (const item of updatedCart.items) {
      const variantId = item.variant_id.toString();
      const selectors = document.querySelectorAll(
        `quantity-selector-component[data-variant-id="${variantId}"], cart-quantity-selector-component[data-variant-id="${variantId}"]`
      );

      for (const selector of selectors) {
        const input = selector.querySelector('input[data-cart-quantity]');
        if (!input) continue;

        input.setAttribute('data-cart-quantity', item.quantity.toString());

        // Update the quantity selector's internal state
        if ('updateCartQuantity' in selector && typeof selector.updateCartQuantity === 'function') {
          selector.updateCartQuantity();
        }
      }
    }
  }

  /**
   * Updates button states for all cart quantity selector components.
   */
  #updateCartQuantitySelectorButtonStates() {
    const cartQuantitySelectors = document.querySelectorAll('cart-quantity-selector-component');
    for (const selector of cartQuantitySelectors) {
      if ('updateButtonStates' in selector && typeof selector.updateButtonStates === 'function') {
        selector.updateButtonStates();
      }
    }
  }

  /**
   * Gets the section id.
   * @returns {string} The section id.
   */
  get sectionId() {
    const { sectionId } = this.dataset;

    if (!sectionId) throw new Error('Section id missing');

    return sectionId;
  }
}

if (!customElements.get('cart-items-component')) {
  customElements.define('cart-items-component', CartItemsComponent);
}

